import { Card, TruncateText } from '@mint-lib/tw-components';
import { cn } from '@mint-lib/tw-utils';

import { getFolderIcon } from '../../../../helpers/knowledge-base/getFolderIcon.js';
import type { FileNode, FolderNode } from '../../../../types/fileSystem.js';
import { FileIcon } from '../FileIcon/FileIcon.jsx';

type MovePickerFolderProps = {
  folder: FolderNode;
  label?: string;
  disabled?: boolean;
  onOpen?: (folder: FolderNode) => void;
};

const MovePickerFolder = ({
  folder,
  label,
  disabled,
  onOpen,
}: MovePickerFolderProps) => {
  const open = disabled ? undefined : onOpen;

  return (
    <Card
      disabled={disabled}
      className={cn('w-full', open && 'cursor-pointer')}
      contentClassName={cn(
        'flex flex-row items-center justify-start gap-2 p-2',
        disabled && 'text-text-disabled',
      )}
      data-dd-action-name="Knowledge base: open move picker folder"
      onClick={() => open?.(folder)}
      tabIndex={disabled ? -1 : 0}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          open?.(folder);
        }
      }}
    >
      <span className={cn('flex shrink-0', disabled && 'opacity-40')}>
        <FileIcon type={getFolderIcon(folder)} />
      </span>
      <TruncateText>{label ?? folder.name}</TruncateText>
    </Card>
  );
};

const MovePickerFile = ({ file }: { file: FileNode }) => (
  <Card
    disabled
    className="w-full"
    contentClassName="flex flex-row gap-2 items-center justify-start p-2 text-text-disabled"
  >
    <span className="flex shrink-0 opacity-40">
      <FileIcon type={file.fileType} />
    </span>
    <TruncateText>{file.fileName}</TruncateText>
  </Card>
);

export { MovePickerFile, MovePickerFolder };
